module.exports = __webpack_public_path__ + "img/mail-send-svgrepo-com (2) 1.b1e098be.svg";